import {
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import {
    getAddressType,
    getIncomeValue,
    getOccupation,
    getPepValue,
    getSourceOfWealth,
} from '../../portfolios/utils';
import enUs from '../../../../lang/en-us';
import { showHelperText, isError } from '../../commercial/Switch/utils';
import DatePickerInput from '../../../../lib/DatePicker';
import { checkForOnlyAlphabets, isFloatingNumber, isNumber } from '../../../../utils/constants';
import { MAX_LENGTHS } from './utils';

const { dashboard } = enUs;

export default function KycFields({ kycFormik }: any) {
    return (
        <div className="new-otm-fields" style={{ borderTop: '1px solid #dedbee', paddingTop: 25 }}>
            <h6>{dashboard.FatcaDeclaration.kycFields.heading}</h6>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={5}>
                    <TextField
                        id="father-name"
                        name="fatherName"
                        variant="outlined"
                        value={kycFormik.values.fatherName}
                        helperText={showHelperText(kycFormik, 'fatherName')}
                        error={isError(kycFormik, 'fatherName')}
                        onChange={(e) => {
                            if (
                                checkForOnlyAlphabets(e.target.value) &&
                                e.target.value.length <= MAX_LENGTHS.fatherName
                            ) {
                                kycFormik.setFieldValue('fatherName', e.target.value);
                            }
                        }}
                        onBlur={kycFormik.handleBlur}
                        label={dashboard.FatcaDeclaration.kycFields.fatherName}
                    />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <TextField
                        id="spouse-name"
                        name="spouseName"
                        variant="outlined"
                        helperText={showHelperText(kycFormik, 'spouseName')}
                        error={isError(kycFormik, 'spouseName')}
                        onChange={(e) => {
                            if (
                                checkForOnlyAlphabets(e.target.value) &&
                                e.target.value.length <= MAX_LENGTHS.spouseName
                            ) {
                                kycFormik.setFieldValue('spouseName', e.target.value);
                            }
                        }}
                        value={kycFormik.values.spouseName}
                        onBlur={kycFormik.handleBlur}
                        label={dashboard.FatcaDeclaration.kycFields.spouseName}
                    />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="pepFlag" variant="outlined">
                            {dashboard.FatcaDeclaration.kycFields.pepFlag}
                        </InputLabel>
                        <Select
                            onChange={kycFormik.handleChange}
                            value={kycFormik.values.pepFlag}
                            name="pepFlag"
                        >
                            {Object.keys(getPepValue).map((item: any) => (
                                <MenuItem value={item}>
                                    {getPepValue ? getPepValue[item] : item}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                            {showHelperText(kycFormik, 'pepFlag')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="annualIncomeSlab" variant="outlined">
                            {dashboard.FatcaDeclaration.kycFields.annualIncomeSlab}
                        </InputLabel>
                        <Select
                            onChange={kycFormik.handleChange}
                            value={kycFormik.values.annualIncomeSlab}
                            name="annualIncomeSlab"
                        >
                            {Object.keys(getIncomeValue).map((item: any) => (
                                <MenuItem value={item}>
                                    {getIncomeValue ? getIncomeValue[item] : item}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                            {showHelperText(kycFormik, 'annualIncomeSlab')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="occupation" variant="outlined">
                            {dashboard.FatcaDeclaration.kycFields.occupation}
                        </InputLabel>
                        <Select
                            onChange={kycFormik.handleChange}
                            value={kycFormik.values.occupation}
                            name="occupation"
                        >
                            {Object.keys(getOccupation).map((item: any) => (
                                <MenuItem value={item}>
                                    {getOccupation ? getOccupation[item] : item}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                            {showHelperText(kycFormik, 'occupation')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormControl variant="outlined" error={isError(kycFormik, 'addressType')}>
                        <InputLabel htmlFor="occupation" variant="outlined">
                            {dashboard.FatcaDeclaration.kycFields.addressType}
                        </InputLabel>
                        <Select
                            onChange={kycFormik.handleChange}
                            value={kycFormik.values.addressType}
                            name="addressType"
                        >
                            {Object.keys(getAddressType).map((item: any) => (
                                <MenuItem value={item}>
                                    {getAddressType ? getAddressType[item] : item}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                            {showHelperText(kycFormik, 'addressType')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormControl variant="outlined" error={isError(kycFormik, 'sourceOfWealth')}>
                        <InputLabel htmlFor="occupation" variant="outlined">
                            {dashboard.FatcaDeclaration.kycFields.sourceOfWealth}
                        </InputLabel>
                        <Select
                            onChange={kycFormik.handleChange}
                            value={kycFormik.values.sourceOfWealth}
                            name="sourceOfWealth"
                        >
                            {Object.keys(getSourceOfWealth).map((item: any) => (
                                <MenuItem value={item}>
                                    {getSourceOfWealth ? getSourceOfWealth[item] : item}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                            {showHelperText(kycFormik, 'sourceOfWealth')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <TextField
                        id="netWorth"
                        name="netWorth"
                        variant="outlined"
                        helperText={showHelperText(kycFormik, 'netWorth')}
                        error={isError(kycFormik, 'netWorth')}
                        onChange={(e) => {
                            if (
                                isFloatingNumber(e.target.value) &&
                                e.target.value.length <= MAX_LENGTHS.netWorth
                            ) {
                                kycFormik.setFieldValue('netWorth', e.target.value);
                            }
                        }}
                        value={kycFormik.values.netWorth}
                        onBlur={kycFormik.handleBlur}
                        label={dashboard.FatcaDeclaration.kycFields.netWorth}
                    />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <DatePickerInput
                        className="net-worth-date"
                        label={dashboard.FatcaDeclaration.kycFields.netWorthDate}
                        name="netWorthDate"
                        value={kycFormik.values.netWorthDate}
                        disableFuture={true}
                        onChange={(e) => {
                            kycFormik.setFieldValue('netWorthDate', e);
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
